// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__26hzv","label":"Radio_label__2sZfh","checkMark":"Radio_checkMark__20wKB","disabled":"Radio_disabled__2SWUO"};